/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Statements/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CreditCards from './CreditCards/index'
import Data from './Data/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import GenerateAction from './GenerateAction/index'
import Locations from './Locations/index'
import MinDueAmount from './MinDueAmount/index'
import Overdue from './Overdue/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Statements({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements"
  
}) {
let tabSelectedStatementsQueryVersionValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.statements.query.version',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="Statements.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Statements.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Data
  viewPath={`${viewPath}/Data`}
 data="tab.selected.statements.query.version"
 key={tabSelectedStatementsQueryVersionValueData}
/>
</div>
<div
  data-testid="Statements.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-1-26qTPI': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-26qTPI': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--blc-3-26qTPI': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical1}`}
>
<Locations
  viewPath={`${viewPath}/Locations`}
/>
<Overdue
  viewPath={`${viewPath}/Overdue`}
/>
<MinDueAmount
  viewPath={`${viewPath}/MinDueAmount`}
/>
<GenerateAction
  viewPath={`${viewPath}/GenerateAction`}
/>
<CreditCards
  viewPath={`${viewPath}/CreditCards`}
/>
</div>
</div>
{children}
</React.Fragment>)
}